import { apiService } from "./api.service";
import { API_CONFIG } from "../config/api";
import type {
  UserData,
  CalendarResponse,
  BookSlotRequest,
  BookSlotResponse,
  UserUpdateResponse,
} from "../types/api.types";
import { FormData } from "../App";

class InterviewService {
  /**
   * Get authenticated user data
   */
  async getUserData(): Promise<UserData> {
    return apiService.get<UserData>(API_CONFIG.endpoints.user);
  }

  /**
   * Update user data and create student_situation
   */
  async updateUserData(formData: FormData): Promise<UserUpdateResponse> {
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      desiredGrade: formData.desiredGrade,
      nationalId: formData.nationalId,
      dateOfBirth: formData.dateOfBirth,
      placeOfBirth: formData.placeOfBirth,
      fatherName: formData.fatherName,
      fatherPhone: formData.fatherPhone,
      motherPhone: formData.motherPhone,
      homeAddress: formData.homeAddress,
      fatherJob: formData.fatherJob,
      fatherEducation: formData.fatherEducation,
      motherEducation: formData.motherEducation,
    };

    return apiService.post<UserUpdateResponse>(
      API_CONFIG.endpoints.userUpdate,
      payload
    );
  }

  /**
   * Get calendar with available dates and time slots
   */
  async getCalendar(): Promise<CalendarResponse> {
    return apiService.get<CalendarResponse>(API_CONFIG.endpoints.calendar);
  }

  /**
   * Get available time slots for a specific date
   */
  async getDateSlots(
    date: string
  ): Promise<{ date: string; day: string; available_slots: string[] }> {
    return apiService.get<{
      date: string;
      day: string;
      available_slots: string[];
    }>(`${API_CONFIG.endpoints.calendar}?date=${date}`);
  }

  /**
   * Book an interview slot
   */
  async bookSlot(
    date: string,
    time: string,
    userId: number
  ): Promise<BookSlotResponse> {
    const payload: BookSlotRequest = {
      date,
      time,
      user_id: userId,
    };

    const isDevMode = false;

    // DEV MODE: Appending dev_mode=1 to the URL to skip real payment
    return apiService.post<BookSlotResponse>(
      `${API_CONFIG.endpoints.bookSlot}?${isDevMode ? "dev_mode=1" : ""}`,
      payload
    );
  }
}

export const interviewService = new InterviewService();
